<div class="container-fluid p-4">
  <div class="row mb-3">
    <div class="col-md-12">
      <h1>Audit Records</h1>
    </div>
  </div>

  <div *ngIf="errorMessage" class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Warning:</strong> {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = null"></button>
  </div>

  <div *ngIf="isLoading" class="text-center p-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2"><em>Loading...</em></p>
  </div>

  <div *ngIf="!isLoading && (!auditRecords || auditRecords.length === 0)" class="alert alert-info">
    <p><em>No audit records found.</em></p>
  </div>

  <div *ngIf="!isLoading && auditRecords && auditRecords.length > 0">
    <!-- Global Search Bar -->
    <div class="row mb-3">
      <div class="col-md-8">
        <div class="input-group">
          <span class="input-group-text">
            🔍 Search All Columns
          </span>
          <input type="text" 
                 class="form-control" 
                 placeholder="Search across all columns..." 
                 [(ngModel)]="globalSearch"
                 (ngModelChange)="onGlobalSearchChange()">
          <button class="btn btn-outline-secondary" 
                  type="button" 
                  (click)="clearFilters()"
                  [disabled]="!globalSearch && !hasActiveColumnFilters()"
                  title="Clear all search and filter criteria">
            Clear
          </button>
        </div>
      </div>
      <div class="col-md-4 text-end">
        <small class="text-muted">
          Showing {{ (filteredAuditRecords?.length ?? 0) }} of {{ (auditRecords && auditRecords.length) || 0 }} records
        </small>
      </div>
    </div>

    <!-- Filterable Table -->
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-dark">
          <tr>
            <th (click)="onSort($event, 'contactId')" style="cursor: pointer; user-select: none;">
              Contact ID {{ getSortIcon('contactId') }}
            </th>
            <th (click)="onSort($event, 'contactName')" style="cursor: pointer; user-select: none;">
              Contact Name {{ getSortIcon('contactName') }}
            </th>
            <th (click)="onSort($event, 'ofacMatchTypeName')" style="cursor: pointer; user-select: none;">
              Match Type {{ getSortIcon('ofacMatchTypeName') }}
            </th>
            <th (click)="onSort($event, 'applicationName')" style="cursor: pointer; user-select: none;">
              Application Name {{ getSortIcon('applicationName') }}
            </th>
            <th (click)="onSort($event, 'createdDate')" style="cursor: pointer; user-select: none;">
              Created Date {{ getSortIcon('createdDate') }}
            </th>
            <th (click)="onSort($event, 'createdBy')" style="cursor: pointer; user-select: none;">
              Created By {{ getSortIcon('createdBy') }}
            </th>
            <th (click)="onSort($event, 'confidence')" style="cursor: pointer; user-select: none;">
              Confidence % {{ getSortIcon('confidence') }}
            </th>
            <th (click)="onSort($event, 'ofacContactId')" style="cursor: pointer; user-select: none;">
              OFAC ID {{ getSortIcon('ofacContactId') }}
            </th>
          </tr>
        </thead>
        <thead class="table-secondary">
          <tr>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.contactId"
                     (ngModelChange)="onColumnFilterChange('contactId', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.contactName"
                     (ngModelChange)="onColumnFilterChange('contactName', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.ofacMatchTypeName"
                     (ngModelChange)="onColumnFilterChange('ofacMatchTypeName', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.applicationName"
                     (ngModelChange)="onColumnFilterChange('applicationName', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.createdDate"
                     (ngModelChange)="onColumnFilterChange('createdDate', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.createdBy"
                     (ngModelChange)="onColumnFilterChange('createdBy', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.confidence"
                     (ngModelChange)="onColumnFilterChange('confidence', $event)">
            </th>
            <th>
              <input type="text" 
                     class="form-control form-control-sm" 
                     placeholder="Filter..." 
                     [(ngModel)]="columnFilters.ofacContactId"
                     (ngModelChange)="onColumnFilterChange('ofacContactId', $event)">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of filteredAuditRecords"
              (click)="onRecordSelected(record)"
              (dblclick)="navigateToDetail(record)"
              [class.table-active]="isRecordSelected(record)"
              style="cursor: pointer;"
              title="Click to select, double-click to view details">
            <td>{{ record.contactId || 'N/A' }}</td>
            <td>{{ record.contactName || '' }}</td>
            <td>{{ record.ofacMatchTypeName || 'N/A' }}</td>
            <td>{{ record.applicationName || 'N/A' }}</td>
            <td>{{ record.createdDate | date }}</td>
            <td>{{ record.createdBy || 'N/A' }}</td>
            <td>{{ record.confidence || 'N/A' }}</td>
            <td>{{ record.ofacContactId?.toString() || 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="filteredAuditRecords && filteredAuditRecords.length === 0" class="alert alert-warning mt-3">
      <p><em>No records match the current filters.</em></p>
    </div>
  </div>
</div>

